export default "__VITE_ASSET__0365502d__"